var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9867 0.382584C13.2473 0.13448 13.5941 -0.00268272 13.9539 3.97663e-05C14.3137 0.00276225 14.6584 0.145157 14.9152 0.397177C15.172 0.649196 15.3209 0.991129 15.3304 1.35082C15.3399 1.71052 15.2093 2.05984 14.9662 2.32508L7.58469 11.5565C7.45776 11.6933 7.30457 11.803 7.13427 11.8791C6.96398 11.9553 6.78007 11.9963 6.59355 11.9998C6.40704 12.0032 6.22174 11.969 6.04874 11.8992C5.87574 11.8294 5.71859 11.7255 5.58669 11.5935L0.691609 6.69846C0.555289 6.57144 0.44595 6.41826 0.370115 6.24806C0.294281 6.07786 0.253503 5.89413 0.250216 5.70783C0.246929 5.52153 0.2812 5.33648 0.350983 5.16371C0.420767 4.99094 0.524634 4.834 0.656389 4.70225C0.788143 4.57049 0.945085 4.46663 1.11785 4.39684C1.29062 4.32706 1.47567 4.29279 1.66197 4.29608C1.84827 4.29936 2.032 4.34014 2.2022 4.41598C2.3724 4.49181 2.52558 4.60115 2.6526 4.73747L6.52649 8.60951L12.9515 0.423284C12.9631 0.409041 12.9754 0.395453 12.9885 0.382584H12.9867Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.dd9ea769aa617ea6c3aeb36c7b507125.svg";
export { ForwardRef as ReactComponent };